const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter: true,
        // sorter: (a, b) => a.name - b.name,
    },
    // {
    //     title: 'Email',
    //     dataIndex: 'email',
    //     sorter: (a, b) => a.email - b.email,
    // },
    {
        title: 'Wallet Account No.',
        dataIndex: 'walletAccountNo',
        sorter: true,
        // sorter: (a, b) => a.walletAccountNo - b. walletAccountNo,
    },
    {
        title: 'Wallet Balance',
        dataIndex: 'balance',
        sorter: true,
        // sorter: (a, b) => a.balance - b.balance,
    },
    {
        title: 'RequestedAmount',
        dataIndex: 'amount',
        sorter: true,
        // sorter: (a, b) => a.amount - b.amount,
    },
    {
        title: 'AmountToPay',
        dataIndex: 'amountTopay',
        sorter: true,
        // sorter: (a, b) => a.amount - b.amount,
    },
    {
        title: 'Fee',
        dataIndex: 'fee',
        sorter: true,
    },
    {
        title: 'Withdraw Type',
        dataIndex: 'withdrawType',
        sorter: true,
        // sorter: (a, b) => a.withdrawType - b.withdrawType,
    },
    {
        title: 'Request Date',
        dataIndex: 'requestDate',
        sorter: true,
        // sorter: (a, b) => a.requestDate - b.requestDate,
    },
    // {
    //     title: 'Accepted Date',
    //     dataIndex: 'actionDate',
    //     sorter: (a, b) => a.actionDate - b.actionDate,
    // },
    // {
    //     title: 'Accepted By',
    //     dataIndex: 'actionDate',
    //     sorter: (a, b) => a.actionDate - b.actionDate ,
    // },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }

];

export default columns;